/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type { Signature as ForcProviderSignature } from "parog-web/components/forc/provider";

interface Signature {
  Args: {
    TextArea?: unknown;
    form?: ForcProviderSignature["Blocks"]["content"][0];
    labelName?: unknown;
    changeset: EmberChangeset;
    propertyName: string;
  };
}

export default class CheckboxWithConditionalComment extends Component<Signature> {
  lastCommentValue = "";

  get isChecked() {
    return this.args.changeset.get(this.args.propertyName) != null;
  }

  @action
  onChangedValue(value) {
    // When unchecking, cache the previous comment value
    if (!value) {
      this.lastCommentValue = this.args.changeset.get(this.args.propertyName);
    }

    this.args.changeset.set(
      this.args.propertyName,
      value ? this.lastCommentValue : null
    );
  }
}
